"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wixFontParam = exports.getWixFont = void 0;
var tslib_1 = require("tslib");
var withWixRequired_1 = require("./withWixRequired");
// Inspired by: https://github.com/wix-private/ecom/blob/e057721e6e654b324dc2c41f434e85b6307546fb/client/settings-editor-common-components/src/utils/fontUtils.ts#L51-L80
function getFontFromPreset(presetName, textPresets) {
    if (!textPresets[presetName]) {
        return null;
    }
    var preset = textPresets[presetName];
    return {
        size: parseInt(preset.size, 10),
        family: preset.fontFamily,
        preset: presetName,
        style: {
            bold: preset.weight === 'bold',
            italic: preset.style === 'italic',
            underline: false,
        },
        fontStyleParam: false,
        value: preset.value,
    };
}
function getWixFont(Wix, name, textPresets) {
    withWixRequired_1.withWixRequired(Wix);
    return getFontFromPreset(name, textPresets);
}
exports.getWixFont = getWixFont;
exports.wixFontParam = function (name, options) {
    if (options === void 0) { options = {}; }
    return function (_a) {
        var Wix = _a.Wix, textPresets = _a.textPresets;
        return (tslib_1.__assign(tslib_1.__assign({}, getWixFont(Wix, name, textPresets)), options));
    };
};
//# sourceMappingURL=getWixFont.js.map